import React from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'

import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { PermissionRedirect } from '../../account/components/sections'

import { BrandCurationTaskPage, BrandCurationTasksPage } from './pages'

const BrandCurationTasksRouter = () => (
  <>
    <Routes>
      <Route
        index
        element={
          <PermissionRedirect
            permissions={PERMISSIONS.BRAND_CURATION_TASK.LIST}
          >
            <BrandCurationTasksPage />
          </PermissionRedirect>
        }
      />
      <Route
        path={APP_ROUTES.BRANDS.children.BRAND_DETAILS.path}
        element={
          <PermissionRedirect
            permissions={[
              PERMISSIONS.BRAND_CURATION_TASK.UPDATE,
              PERMISSIONS.BRAND_CURATION_TASK.GET,
            ]}
          >
            <BrandCurationTaskPage />
          </PermissionRedirect>
        }
      />
    </Routes>

    <Outlet />
  </>
)

export default BrandCurationTasksRouter
